// extracted by mini-css-extract-plugin
export default {"container":"Header_container__5hRTM","logo":"Header_logo__5CYNx","right":"Header_right__NZAzv","menu":"Header_menu__TjsHw","tire":"Header_tire__ujrdP","bars":"Header_bars__Pgq4a"};